export const HOME = {
  emergentLink: "emergent-link",
};

export const AUTH = {
  loginForm: "login-form",
  emailInput: "email-input",
  passwordInput: "password-input",
  loginButton: "login-submit-btn",
  googleLoginButton: "google-login-btn",
  logoutButton: "logout-btn",
};

export const DASHBOARD = {
  container: "dashboard-container",
  urgentWidget: "urgent-widget",
  bulletinWidget: "bulletin-widget",
  announcementsWidget: "announcements-widget",
  birthdaysWidget: "birthdays-widget",
  campaignsWidget: "campaigns-widget",
  trainingsWidget: "trainings-widget",
  statsWidget: "stats-widget",
};

export const NAV = {
  sidebar: "main-sidebar",
  sidebarItem: "sidebar-nav-item",
  mobileMenu: "mobile-menu-btn",
  userMenu: "user-menu",
};

export const CONTENT = {
  createBtn: "create-content-btn",
  editBtn: "edit-content-btn",
  deleteBtn: "delete-content-btn",
  saveBtn: "save-content-btn",
  cancelBtn: "cancel-content-btn",
  searchInput: "search-input",
  filterSelect: "filter-select",
  contentList: "content-list",
  contentItem: "content-item",
  contentDetail: "content-detail",
};

export const FORMS = {
  formList: "form-list",
  formItem: "form-item",
  submitBtn: "form-submit-btn",
  mySubmissions: "my-submissions",
};

export const ADMIN = {
  userTable: "admin-user-table",
  addUserBtn: "admin-add-user-btn",
  editUserBtn: "admin-edit-user-btn",
  deactivateUserBtn: "admin-deactivate-user-btn",
};
